import { render, staticRenderFns } from "./applyItemManage.vue?vue&type=template&id=b720e850&"
import script from "./applyItemManage.vue?vue&type=script&lang=js&"
export * from "./applyItemManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports